var _defs, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdFs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PDFs",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.09 62.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed1c24;stroke-miterlimit:10;stroke-width:.94px;}.cls-1,.cls-2{stroke:#231f20;}.cls-3{fill:#231f20;font-family:MyriadPro-Bold, 'Myriad Pro';font-size:6.23px;}.cls-2{fill:none;stroke-linejoin:round;stroke-width:1.95px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "30.48 18.53 30.48 27.6 38.93 27.6 30.48 18.53"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.94 18.53 30.48 18.53 38.93 27.6 38.93 58.47 8.94 58.47 8.94 18.53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.72,
    y: 31.12,
    width: 18.62,
    height: 0.52,
    rx: 0.23,
    ry: 0.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.72,
    y: 36.4,
    width: 18.62,
    height: 0.52,
    rx: 0.23,
    ry: 0.23
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.72,
    y: 41.69,
    width: 18.62,
    height: 0.52,
    rx: 0.23,
    ry: 0.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.72,
    y: 46.97,
    width: 14.3,
    height: 0.52,
    rx: 0.23,
    ry: 0.23
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.72,
    y: 52.26,
    width: 9.56,
    height: 0.52,
    rx: 0.23,
    ry: 0.23
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(14.28 26.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdFs);
export default __webpack_public_path__ + "static/media/PDFs.e120579f4858da4ac2df3d3930064dd9.svg";
export { ForwardRef as ReactComponent };